import * as ClaimActionTypes from '../actions/claims';

import initialState from './initialState';
import { errorResponseHandler } from '../utils/error-utils';

export default (state=initialState.claims, action) => {
   const { payload, type } = action;

   switch(type) {

        case ClaimActionTypes.LIST_CLAIMS:
        case ClaimActionTypes.LIST_CLAIMS_PENDING:
            return { ...state, claims_loading: true }

        case ClaimActionTypes.LIST_CLAIMS_REJECTED:
            return { ...state, claims_loading: false, ...errorResponseHandler(payload, 'ClaimList') }

        case ClaimActionTypes.LIST_CLAIMS_FULFILLED:
            return { ...state, claims_loading: false, claims: payload.data }
        
        case ClaimActionTypes.FILE_CLAIM:
        case ClaimActionTypes.FILE_CLAIM_PENDING:
            return { ...state, claimError: false, claimUploading: true, claimSuccess: false }

        case ClaimActionTypes.FILE_CLAIM_REJECTED:
            return { ...state, claimError: true, claimUploading: false,  ...errorResponseHandler(payload, 'FileClaim') }

        case ClaimActionTypes.FILE_CLAIM_FULFILLED:
            return { ...state, claimError: false, claimUploading: false, claimSuccess: true, successMessage: payload.data.Info }
        
        
        default:
           return state;
   }
}


// WEBPACK FOOTER //
// ./src/reducers/claims.js